module.exports = __webpack_public_path__ + "static/media/veggies.b2d33a35.svg";